import { connect } from 'react-redux'
import {
  compose,
  branch,
  renderComponent,
  renderNothing
} from 'recompose'

function mapStateToProps(state) {
  return {
    permissionsList: state.user.permissions
  }
}
export function hasPermission(code, permissionCodes) {
  if (code) {
    const hasPermission = permissionCodes.includes(code)
    return hasPermission
  }
  return true
}

export const permissionHOC = (permissionCode, FailComponent) => compose(
  connect(mapStateToProps),
  branch(
    props => !hasPermission(permissionCode, props.permissionsList),
    props => FailComponent ? renderComponent(FailComponent)(props) : renderNothing()
  )
)

export default permissionHOC



// WEBPACK FOOTER //
// ./components/hoc/permission.js